import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { Providers } from './providers';
import { router } from './router';
import { useAuthStore } from '@/features/auth';
import { BetaGate } from '@/components/gate/beta-gate';
import { ChunkLoadErrorBoundary } from '@/components/error-boundary';
import { Toaster } from '@/components/ui/toaster';

function AppContent() {
  const checkAuth = useAuthStore((state) => state.checkAuth);

  // Check authentication on app load
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <ChunkLoadErrorBoundary>
      <RouterProvider router={router} />
    </ChunkLoadErrorBoundary>
  );
}

export default function App() {
  return (
    <BetaGate>
      <Providers>
        <AppContent />
        <Toaster />
      </Providers>
    </BetaGate>
  );
}
